// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React         = require("react");
var ReasonReact   = require("reason-react/lib/js/src/ReasonReact.js");
var QuickAddMeal  = require("../components/QuickAddMeal");
var PreviousMeals = require("../components/PreviousMeals");

var component = ReasonReact.statelessComponent("OverviewScreen");

function make(meals, onQuickAddMeal, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "OverviewScreen"
                }, ReasonReact.element(/* None */0, /* None */0, QuickAddMeal.make(meals, onQuickAddMeal, /* array */[])), ReasonReact.element(/* None */0, /* None */0, PreviousMeals.make(meals, /* array */[])));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/screen/OverviewScreen.re
// module id = 379
// module chunks = 0